module.exports = require("querystring");


/*****************
 ** WEBPACK FOOTER
 ** external "querystring"
 ** module id = 5
 ** module chunks = 0
 **/